import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import Language from "../../language/language";
import {
  Upload,
  Button,
  message,
  Radio,
  Select,
  Alert,
  Input,
  Icon,
  Modal,
  Spin,
  Progress
} from "antd";
import { $const, $util } from "../../../helper";
import classnames from "classnames";
import moment from "moment";
import TerraUploader from "@dji/terra-uploader";
import Modal1 from "../modal/modal";
import { inject, observer } from "mobx-react";
import agent from "../../../agent";
import ReactGA from "react-ga";
import GameTimeReservation from "../../formList/gameTimeReservationForm";
import UploadOSS from "../../../lego/uploadOss";
import PersonalInfoInput from "./personalInfoInput";
import JobSelect from "./jobSelect";
import getMd5 from "../../../lego/getMd5";

import "../stylesheets/gameForm.scss";

const RadioGroup = Radio.Group;
const Option = Select.Option;
const { TextArea } = Input;
const transferJobDesc = (
  <div>
    <p className="form-recruitment--normal-text form-recruitment--normal-title">{"注意事项"}</p>
    <p className="form-recruitment--normal-text">
      {"1. 秋季校园招聘项目可选择一个除投递职位外其他感兴趣的职位，"}
      <span className="form-recruitment--normal-text form-recruitment--normal-bold">
        {"若无可不选"}
      </span>
      {"。"}
    </p>
    <p className="form-recruitment--normal-text">
      {"2. 意向信息仅供参考，仅当所选的“其他感兴趣的职位”有空缺时，HR可能视情况发起流程。"}
    </p>
    <p className="form-recruitment--normal-text">
      {"3. 本次秋季校园招聘仅可投递一次，请确保投递职位、简历信息正确，一经投递不可修改。"}
    </p>
  </div>
);
@inject("authStore", "gameStore", "teamStore", "commonStore", "languageStore", "personGameStore")
@withRouter
@observer
export default class GameForm extends React.Component {
  constructor() {
    super();
    this.personalInfoRef = React.createRef();
  }

  static defaultProps = {
    // 是否是报名提交
    isRegistration: false,
    isLoop: false
  };
  // 提交给后端的docker相关信息。
  largeFileInfo = {
    sourceType: 1
  };
  // uuid
  largeFileUuid = "";
  largeFileUploadTime = null;
  sensorTypeOrderNum = -1;
  timeMeetingInput = React.createRef();
  timeReservationComponent = React.createRef();
  state = {
    submitLoading: false,
    form: [],
    registrationId: undefined,
    registionUuid: undefined,
    inputs: [],
    formNameUuid: undefined,
    file: {},
    largeFile: [],
    uploadOss: undefined,
    messages: {},
    timeMeetingRef: null,
    modalVisible: false,
    curRecuritInputUuid: "",
    // 是否展示大文件上传进度弹框
    largeUploadProgressVisible: false,
    // 大文件上传进度
    largeFileProgress: 0,
    // 大文件是否上传完成
    isLargeUploadReady: false,
    // 点击提交是否展示“剩余提交次数”弹框
    showBeforeUploadTip: false,
    // 大文件上传失败
    largeUploadError: false,
    // 大文件上传失败原因
    largeUploadErrorReason: "unknown",
    // 是否展示调剂职位选择
    transferPositionState: false,
    // 当前选择的职位类型：primary-第一职位, transfer-调剂职位
    jobSelectType: "primary",
    primaryJobName: "",
    primaryJobId: "",
    transferJobName: "",
    transferJobId: "",
    // 是否完成计算md5
    isMd5Ready: false,
    // 大文件是否上传完成，触发了didUpload
    isDidUpload: false,
    currentMd5: null
  };

  componentDidMount() {
    const teamInfo = this.props.teamStore.teamInfo;
    const userInfo = this.props.authStore.user;
    this.largeFileInfo = Object.assign(this.largeFileInfo, {
      gameId: teamInfo && teamInfo.gevent && teamInfo.gevent.id,
      userId: userInfo && userInfo.id,
      teamId: teamInfo && teamInfo.id,
      // 当前任务所属环节数
      stage: this.getCurStage(),
      // 当前所属环节id
      stageId: this.props.stageId
    });
    let formNameUuid = this.props.form.nameUuid;
    let registionUuid = undefined;
    let registrationId = undefined;
    let submitNum = 0;
    const gameData = this.props.gameData;
    if (gameData) {
      registionUuid = gameData.uuid;
      registrationId = gameData.id;
      if (
        gameData.commonInputs &&
        gameData.commonInputs.nodes &&
        gameData.commonInputs.nodes.length > 0
      ) {
        submitNum = this.sumHistory(this.props.form.id, gameData.commonInputs.nodes);
      }
    }
    let inputs = [];
    let myInputs = this.formatInput([...this.props.form.formInputs.nodes]);
    myInputs.forEach(item => {
      if (item.input) {
        let input = {
          id: item.id,
          keyNameUuid: item.keyNameUuid,
          required: item.required,
          value: undefined,
          type: item.input.valueType,
          viewType: item.input.viewType,
          labelUuidI18n: item.labelUuidI18n
        };
        if (item.responsiveFormInputId && item.responsiveValue) {
          // 有关联数据
          input.responsiveValue = item.responsiveValue;
          let responsiveIteam = myInputs.find(responsive => {
            return item.responsiveFormInputId === responsive.id;
          });
          if (responsiveIteam) {
            input.responsiveKeyNameUuid = responsiveIteam.keyNameUuid;
            input.responsiveRealValue = undefined;
          }
        }
        inputs.push(input);
      }
    });
    this.setState({
      formNameUuid: formNameUuid,
      registionUuid: registionUuid,
      registrationId: registrationId,
      // 初始化表单数据参数值（inputs）
      inputs: inputs,
      submitNum: submitNum
    });
  }

  componentWillUnmount() {
    this.largeUploadCancel();
    $util.breakLoginOff();
  }

  componentDidUpdate(pre) {
    let sum = 0;
    let registrationId;
    const gameData = this.props.gameData;
    if (gameData) {
      registrationId = gameData.id;
      if (
        gameData.commonInputs &&
        gameData.commonInputs.nodes &&
        gameData.commonInputs.nodes.length > 0
      ) {
        sum = this.sumHistory(this.props.form.id, gameData.commonInputs.nodes);
      }
    }
    if (sum !== this.state.submitNum) {
      this.setState({
        submitNum: sum
      });
    }
    if (registrationId !== this.state.registrationId) {
      this.setState({
        registrationId: registrationId
      });
    }
  }

  // 获取当前环节数
  getCurStage = () => {
    const teamInfo = this.props.teamStore.teamInfo;
    const curStageId = this.props.stageId;
    if (teamInfo && teamInfo.myFlow && teamInfo.myFlow.stages && teamInfo.myFlow.stages.nodes) {
      const stages = teamInfo.myFlow.stages.nodes;
      return stages.findIndex(item => item.id === curStageId) + 1;
    }
    return 0;
  };

  /**
   * 通过此方法设置表单值
   */
  setInputValue = (value, uuid) => {
    let inputs = this.state.inputs;
    let message = {};
    // 同时检验是否存在关联项
    inputs = inputs.map(input => {
      if (input.keyNameUuid === uuid) {
        input.value = value;
        let tmp = {};
        tmp[uuid] = value ? false : true;
        message = Object.assign({}, message, tmp);
      }
      if (input.responsiveKeyNameUuid === uuid) {
        input.responsiveRealValue = value;
      }
      return input;
    });
    // 检测赛区选择的数值选择 如果之前有message则 符合要求的话 去掉message提示
    let division = [];
    inputs.length > 0 &&
      inputs.forEach(item => {
        if (item.viewType === $const.INPUTVIEWTYPE.DIVISION) {
          division.push(item);
        }
      });
    if (
      division.length === 2 &&
      division[0].value &&
      division[1].value &&
      division[0].value !== division[1].value
    ) {
      // 志愿赛区不重复 去掉message
      let tmp = {};
      tmp[division[0].keyNameUuid] = false;
      tmp[division[1].keyNameUuid] = false;
      message = Object.assign({}, message, tmp);
    }
    if (
      division.length === 2 &&
      division[0].value &&
      division[1].value &&
      division[0].value === division[1].value
    ) {
      let tmp2 = {};
      tmp2[division[1].keyNameUuid] = <Language resource="CANNOT_THE_SAME" />;
      message = Object.assign({}, message, tmp2);
    }
    this.setState({
      inputs: Object.assign([], inputs),
      messages: Object.assign({}, this.state.messages, message)
    });
  };

  formatInput = formInputs => {
    let inputs = [];
    formInputs.forEach(input => {
      if (input.inputSource === $const.INPUTSOURCE.WWW) {
        inputs.push(input);
      }
    });
    return inputs;
  };

  feedBackInput = formInputs => {
    let inputs = [];
    formInputs.forEach(input => {
      if (input.inputSource === $const.INPUTSOURCE.CMS) {
        inputs.push(input);
      }
    });
    return inputs;
  };

  uploadFile = (file, uuid) => {
    let that = this;
    this.setState({
      [`uploadLoadIng-${uuid}`]: true
    });
    agent.Common.getV2UploadSts({
      source_id:
        this.props.gameType === $const.SOURCE_TYPE.TEAM
          ? this.props.teamStore.teamInfo.id
          : this.props.authStore.user.id,
      source_type: this.props.gameType,
      bucket_type: "private"
    }).then(res => {
      if (res.status === 0) {
        const config = res.result; // config为【请求上传凭证 /upload/sts_init】接口返回的上传凭证，即result
        const terraOptions = {
          config: res.result, // upload config get from Terra's【/upload/sts_init】API
          onSuccess: function() {
            that.setState({
              [`uploadLoadIng-${uuid}`]: false
            });
            // 上传成功
            let myFile = {};
            // 目前只支持选择一个文件
            myFile[uuid] = [
              {
                name: file.name,
                size: file.size,
                type: file.type,
                uid: file.uid
              }
            ];
            that.setState({
              file: Object.assign({}, that.state.file, myFile)
            });
            that.setInputValue(
              `${window.location.protocol}//${config.cloudBucketName}.${config.endPoint}/${config.objectKey}.${file.name}`,
              uuid
            );
          },
          onError: function(err) {
            that.setState({
              [`uploadLoadIng-${uuid}`]: false
            });
          }
        };
        const uploader = new TerraUploader(file, terraOptions);
        uploader.start();
      }
    });
  };

  renderFileUpload = fileInfo => {
    if (!fileInfo) {
      return null;
    }
    const lang = this.props.languageStore.lang;
    return (
      <div key={fileInfo.id} className="form-input">
        <div uuid={fileInfo.keyNameUuid} className="file-select">
          <div className="file-remark">
            {fileInfo.labelUuidI18n && fileInfo.labelUuidI18n[lang]}
          </div>
          <div className="upload-button">
            <Upload
              className={classnames("file-upload-button", fileInfo.keyNameUuid)}
              fileList={
                this.state.file[fileInfo.keyNameUuid] && this.state.file[fileInfo.keyNameUuid]
                  ? this.state.file[fileInfo.keyNameUuid]
                  : ""
              }
              multiple={false}
              onRemove={file => {
                let myFile = {};
                myFile[fileInfo.keyNameUuid] = [];
                this.setState({
                  file: Object.assign({}, this.state.file, myFile)
                });
                this.setInputValue(undefined, fileInfo.keyNameUuid);
              }}
              showUploadList={true}
              accept={fileInfo.fileType ? fileInfo.fileType : ""}
              beforeUpload={file => {
                const size = file.size / 1024 / 1024;
                if (fileInfo.fileType && file.type !== fileInfo.fileType) {
                  message.error(`上传文件类型错误，请重新上传`);
                  return false;
                }
                if (
                  (fileInfo.min && size < fileInfo.min) ||
                  (fileInfo.max && size > fileInfo.max)
                ) {
                  message.error(this.props.languageStore.getResource(lang, "FILE_SIZE_LIMIT"));
                  return false;
                }
                this.uploadFile(file, fileInfo.keyNameUuid);
                return false;
              }}
            >
              <Button
                style={{
                  display: this.state[`uploadLoadIng-${fileInfo.keyNameUuid}`] ? "block" : "none"
                }}
                loading={true}
              >
                <Language resource="SELECT_FILE" />
              </Button>
              <Button
                style={{
                  display: this.state[`uploadLoadIng-${fileInfo.keyNameUuid}`] ? "none" : "block"
                }}
                loading={false}
              >
                <Language resource="SELECT_FILE" />
              </Button>
            </Upload>
          </div>
          <div className="file-remark">{fileInfo.tipUuidI18n && fileInfo.tipUuidI18n[lang]}</div>
        </div>
        {fileInfo.required && this.state.messages[fileInfo.keyNameUuid] ? (
          <div className="error">{this.state.messages[fileInfo.keyNameUuid]}</div>
        ) : null}
      </div>
    );
  };

  largeUploadProgressListener = p => {
    this.setState({
      largeFileProgress: Math.round(p * 100)
    });
  };

  largeUploadErrorListener = err => {
    let info = "unknown";
    if (typeof err === "string") {
      info = err;
    } else if (err && err.message) {
      info = err.message;
    }
    this.setState({
      largeUploadError: true,
      largeUploadErrorReason: info
    });
  };

  afterLargeUploadSucListener = () => {
    this.setState({
      largeFile: [],
      uploadOss: undefined,
      isLargeUploadReady: true,
      largeFileProgress: 100,
      isMd5Ready: false,
      isDidUpload: false
    });
    this.setInputValue(undefined, this.largeFileUuid);
    this.largeFileUuid = "";
    $util.breakLoginOff();
    ReactGA.event({
      category: "large_file_upload_succeeded",
      action: "click",
      label: "大文件上传成功"
    });
    const lang = this.props.languageStore.lang;
    this.props.commonStore.gTag("event", "largeFileUploadedSuccessfully", {
      pageName: "gameApplyInfo",
      competitionName:
        this.props.teamStore.teamInfo &&
        this.props.teamStore.teamInfo.gevent &&
        this.props.teamStore.teamInfo.gevent.titleUuidI18n[lang]
    });
  };

  largeUploadSucListener = () => {
    this.submit();
  };

  largeUploadCancel = () => {
    this.state.uploadOss &&
      !this.state.uploadOss.isUploadReady &&
      this.state.uploadOss.uploadFileCancel();
    document.body.style.overflow = "";
    this.setState({
      largeUploadProgressVisible: false,
      isLargeUploadReady: false,
      largeFileProgress: 0
    });
  };

  largeUploadFileCreated = (res, uuid) => {
    this.setInputValue(res, uuid);
    this.props.gameStore.submitButtonStateNormal();
    $util.keepLoginAlive();
    const uploadOss = this.state.uploadOss;
    this.largeFileUuid = uuid;
    // 用于记录当前文件创建的时间，计算md5的时候进行一一对应
    this.largeFileUploadTime = Date.now();
    this.largeFileInfo = Object.assign(this.largeFileInfo, {
      fileId: uploadOss && uploadOss.objectName,
      fileUrl: uploadOss && uploadOss.href,
      submitCount: this.props.submitCount
    });
  };

  startUpload = ({ startWithBreakpoint }) => {
    if (startWithBreakpoint) {
      this.props.commonStore.trackReport.fnTrackByEle(this.uploadBreakpointRef, "data-click");
    } else {
      this.props.commonStore.trackReport.fnTrackByEle(this.uploadNormalRef, "data-click");
    }
  };

  renderLargeFileUpload = fileInfo => {
    if (!fileInfo) {
      return <div />;
    }
    const lang = this.props.languageStore.lang;
    return (
      <div key={fileInfo.id} className="form-input">
        <div uuid={fileInfo.keyNameUuid} className="file-select">
          <div className="file-remark">
            {fileInfo.labelUuidI18n && fileInfo.labelUuidI18n[lang]}
          </div>
          <div className="upload-button">
            <Upload
              className={classnames("file-upload-button", fileInfo.keyNameUuid)}
              multiple={false}
              fileList={this.state.largeFile}
              showUploadList={true}
              accept={fileInfo.fileType ? fileInfo.fileType : ""}
              onRemove={() => {
                this.setState({
                  largeFile: []
                });
                this.setInputValue(undefined, fileInfo.keyNameUuid);
              }}
              beforeUpload={file => {
                this.props.gameStore.submitButtonStateLoading();
                if (!file.type.includes("tar")) {
                  message.error(`上传文件类型错误，请重新上传`);
                  this.props.gameStore.submitButtonStateNormal();
                  return false;
                }
                // 上传时先判断文件大小是否小于10G
                if (file.size && file.size > 10 * 1024 * 1024 * 1024) {
                  message.error(`文件超出规定大小，请调整后提交。`);
                  this.props.gameStore.submitButtonStateNormal();
                  return false;
                }
                ReactGA.event({
                  category: "large_file_uploaded",
                  action: "click",
                  label: "大文件上传"
                });
                this.props.commonStore.gTag("event", "largeFileUpload", {
                  pageName: "gameApplyInfo",
                  buttonName: "大文件上传",
                  competitionName:
                    this.props.teamStore.teamInfo &&
                    this.props.teamStore.teamInfo.gevent &&
                    this.props.teamStore.teamInfo.gevent.titleUuidI18n[lang]
                });
                const uploadOss = new UploadOSS({
                  file,
                  progressListener: this.largeUploadProgressListener,
                  errorListener: this.largeUploadErrorListener,
                  didUpload: () => {
                    this.setState({
                      isDidUpload: true
                    });
                    // 如果md5还未计算完成，则等计算完成以后提交
                    if (this.state.isMd5Ready) {
                      this.largeUploadSucListener(fileInfo.keyNameUuid);
                    }
                  },
                  created: res => this.largeUploadFileCreated(res, fileInfo.keyNameUuid),
                  startUpload: this.startUpload
                });
                this.setState({
                  largeFile: [file],
                  uploadOss
                });
                return false;
              }}
            >
              <Button>
                <Language resource="SELECT_FILE" />
              </Button>
            </Upload>
          </div>
          <div className="file-remark">{fileInfo.tipUuidI18n && fileInfo.tipUuidI18n[lang]}</div>
          <div
            ref={ref => (this.uploadBreakpointRef = ref)}
            data-log={$util.log({
              uploadTrigger: "breakpoint"
            })}
          />
          <div
            ref={ref => (this.uploadNormalRef = ref)}
            data-log={$util.log({
              uploadTrigger: "normal"
            })}
          />
          <div
            ref={ref => (this.uploadMd5Ref = ref)}
            data-log={$util.log({
              uploadTrigger: "normal",
              controlPlaceholder: "上报md5",
              controlId: this.state.currentMd5,
              controlLabel: this.state.uploadOss ? this.state.uploadOss.objectName : ""
            })}
          />
        </div>
        {fileInfo.required && this.state.messages[fileInfo.keyNameUuid] ? (
          <div className="error">{this.state.messages[fileInfo.keyNameUuid]}</div>
        ) : null}
      </div>
    );
  };

  renderSubmitButton = submit => {
    if (!submit) {
      return null;
    }
    let slug = false;
    if (this.props.isLoop) {
      if (this.props.status === $const.STAGE_STATUS.PROGRESS) {
        // 无限提交环节  待处理 不能提交
        slug = true;
      }
    } else {
      // 非无限提交环节 有时间限制
      if (
        this.props.beginAt &&
        this.props.endAt &&
        moment() > moment(this.props.endAt) &&
        moment() < moment(this.props.beginAt)
      ) {
        slug = true;
      }
      // 如果环节 有提交次数限制且 已经满足提交次数 不能提交
      if (this.props.form.numLimit && this.state.submitNum === this.props.form.numLimit) {
        slug = true;
      }
    }
    return (
      <div
        key={submit.id}
        className="submit"
        data-click
        data-log={$util.log({
          controlId: submit.input.viewType,
          controlPlaceholder: submit.placeholderUuidI18n[this.props.languageStore.lang],
          controlPosition: submit.orderNum + 1
        })}
      >
        <Button
          disabled={slug}
          onClick={this.checkValues}
          loading={this.props.gameStore.submitButtonLoading}
        >
          <span>{submit.placeholderUuidI18n[this.props.languageStore.lang]}</span>
        </Button>
      </div>
    );
  };

  sumHistory = (formId, nodes) => {
    let num = 0;
    nodes.forEach(item => {
      if (item.formId === formId) {
        num += 1;
      }
    });
    return num;
  };
  // 点击提交，校验必填字段
  checkIsRequired = () => {
    let slug = [];
    this.state.inputs.length > 0 &&
      this.state.inputs.forEach(item => {
        if (!item.responsiveValue) {
          // 无关联数据
          if (
            item.required &&
            (item.value === undefined || item.value === "") &&
            item.viewType !== $const.INPUTVIEWTYPE.TIME_RESERVATION &&
            item.viewType !== $const.INPUTVIEWTYPE.PERSONAL_INFO
          ) {
            slug.push(item);
          }
        } else {
          // 有关联数据
          if (
            item.required &&
            item.responsiveValue === item.responsiveRealValue &&
            (item.value === undefined || item.value === "") &&
            item.viewType !== $const.INPUTVIEWTYPE.TIME_RESERVATION &&
            item.viewType !== $const.INPUTVIEWTYPE.PERSONAL_INFO
          ) {
            slug.push(item);
          }
        }
      });
    return slug;
  };

  checkDivision = () => {
    let division = [];
    this.state.inputs.length > 0 &&
      this.state.inputs.forEach(item => {
        if (item.viewType === $const.INPUTVIEWTYPE.DIVISION) {
          division.push(item);
        }
      });
    if (division.length === 2 && division[0].value === division[1].value) {
      // 志愿赛区不能重复
      message[division[1].keyNameUuid] = <Language resource="CANNOT_THE_SAME" />;
      this.setState({
        messages: Object.assign({}, this.state.messages, message)
      });
      return false;
    }
    return true;
  };

  startUploadLargeFile = () => {
    this.state.uploadOss.uploadFile();
    $util.keepLoginAlive();
    document.body.style.overflow = "hidden";
    this.setState(
      {
        largeUploadProgressVisible: true
      },
      this.calculateDockerMd5
    );
  };

  /**
   * 计算dokcer文件的md5值，使用的是webworker
   */
  calculateDockerMd5 = () => {
    const [file] = this.state.largeFile;
    const startTime = performance.now();
    getMd5(file, this.largeFileUploadTime, 100 * 1024 * 1024)
      .then(({ md5, fileId }) => {
        if (this.largeFileUploadTime === fileId) {
          console.log(`文件的md5值为：${md5}，耗时为：${performance.now() - startTime}`);
          this.largeFileInfo = Object.assign(this.largeFileInfo, {
            fileMd5: md5
          });
          this.setState(
            {
              isMd5Ready: true,
              currentMd5: md5
            },
            () => {
              try {
                this.props.commonStore.trackReport.fnTrackByEle(this.uploadMd5Ref, "data-click");
              } catch (error) {
                console.log(error);
              }
            }
          );
          // 如果上传完成了，则直接进行任务提交
          this.state.isDidUpload && this.largeUploadSucListener(this.largeFileUuid);
        } else {
          console.log(`非当前文件的md5值为：${md5}，耗时为：${performance.now() - startTime}`);
        }
      })
      .catch(error => {
        console.error(error);
        this.setState(
          {
            largeUploadError: true,
            largeUploadErrorReason:
              typeof error === "string" ? error : "获取文件md5失败，请刷新页面重试"
          },
          () => {
            // 停止上传
            this.state.uploadOss &&
              !this.state.uploadOss.isUploadReady &&
              this.state.uploadOss.uploadFileCancel();
          }
        );
      });
  };

  confirmBeforeUploadTip = () =>
    this.setState(
      {
        showBeforeUploadTip: false
      },
      () => {
        this.startUploadLargeFile();
      }
    );

  closeBeforeUploadTip = () =>
    this.setState({
      showBeforeUploadTip: false
    });

  hasPersonalInfoInput = () => {
    return this.state.inputs.filter(item => item.viewType === $const.INPUTVIEWTYPE.PERSONAL_INFO);
  };

  checkValues = () => {
    const currentTeamIsSpecialGame = this.props.teamStore.currentTeamIsSpecialGame;
    if (
      !currentTeamIsSpecialGame &&
      this.props.gameType !== $const.SOURCE_TYPE.PERSON &&
      this.props.teamStore.teamInfo &&
      this.props.teamStore.teamInfo.status !== $const.TEAM_STATUS.LOCKED
    ) {
      // 战队资料未提交（未锁定状态），不允许提交
      Modal.warning({
        title: this.props.languageStore.getResource(
          this.props.languageStore.lang,
          "TEAM_INFO_NOT_CONFIRMED"
        ),
        content: this.props.languageStore.getResource(
          this.props.languageStore.lang,
          "TEAM_INFO_NOT_CONFIRMED_DETAILS"
        ),
        okText: this.props.languageStore.getResource(
          this.props.languageStore.lang,
          "KICK_OUT_CONFIRM"
        )
      });
      return;
    }
    //时间预约校验
    if (this.state.timeMeetingRef && !this.state.timeMeetingRef.checkValues()) {
      return;
    }
    let arr = this.checkIsRequired();
    const hasPersonalInfoInput = this.hasPersonalInfoInput();
    if (hasPersonalInfoInput) {
      const personalInfoError = this.personalInfoSubmit();
      const values = this.getPersonalInfoValues();
      if (personalInfoError) {
        return;
      } else if (values) {
        const uuid = hasPersonalInfoInput[0].keyNameUuid;
        uuid && this.setInputValue(values, uuid);
      }
    }
    // 检测是否有必填未填的信息
    if (arr.length > 0) {
      // 必填项目有未提交
      let message = {};
      for (let i in arr) {
        let keys = [];
        keys.push(arr[i].labelUuidI18n);
        message[arr[i].keyNameUuid] = <Language resource="IS_REQUIRED" keys={keys} />;
      }
      this.setState({
        messages: Object.assign({}, this.state.messages, message)
      });
      return;
    }
    // 检测是否有赛区提交内容---第一志愿赛区第二志愿赛区不能重复
    if (!this.checkDivision()) {
      return;
    }
    // 有大文件待上传
    if (this.state.uploadOss && !this.state.uploadOss.isUploadReady) {
      // 如果是报名环节
      if (this.props.isRegistration && !this.props.gameData) {
        if (
          $util.checkTeamMembers(this.props.teamStore.teamInfo) &&
          $util.checkTeamInfo(this.props.teamStore.teamInfo)
        ) {
          // 提示即将锁定队伍
          this.setState({
            gameRegistrationModal: true
          });
        } else {
          // 不符合要求
          this.props.gameStore.showTeamMemberMissing();
        }
      }
      // 该表单有设置提交次数限制
      else if (this.props.form.numLimit) {
        this.setState({
          showBeforeUploadTip: true
        });
      } else {
        this.startUploadLargeFile();
      }
      return;
    }

    ReactGA.event({
      category: "Recruit_Sub_Resume",
      action: "Click",
      label: "提交"
    });
    try {
      // 团队赛的比赛名次
      const teamMatchName =
        this.props.teamStore.teamInfo &&
        this.props.teamStore.teamInfo.gevent &&
        this.props.teamStore.teamInfo.gevent.titleUuidI18n[this.props.languageStore.lang];
      // 个人赛的比赛名称
      const personalMatchName =
        this.props.personGameStore.info &&
        this.props.personGameStore.info.event &&
        this.props.personGameStore.info.event.titleUuidI18n &&
        this.props.personGameStore.info.event.titleUuidI18n[this.props.languageStore.lang];
      this.props.commonStore.gTag("event", "recruitSubResume", {
        pageName: "gameApplyInfo",
        buttonName: "提交",
        competitionName: teamMatchName || personalMatchName || ""
      });
    } catch (error) {
      console.error(error);
    }
    this.submit();
  };

  personalInfoSubmit = () => {
    if (this.personalInfoRef && this.personalInfoRef.handleSubmit) {
      return this.personalInfoRef.handleSubmit();
    }
  };

  getPersonalInfoValues = () => {
    if (this.personalInfoRef && this.personalInfoRef.getPersonalInfoValues) {
      return this.personalInfoRef.getPersonalInfoValues();
    }
  };

  setGameStoreForm = gameRegistrationId => {
    let form = {
      variables: {
        input: {
          formNameUuid: this.state.formNameUuid,
          registrationId: gameRegistrationId,
          stringAttributes: [],
          intAttributes: []
        }
      }
    };

    this.state.inputs.length > 0 &&
      this.state.inputs.forEach(item => {
        // 过滤那些有关联数据 且关联数据不对的情况
        if (item.responsiveValue && item.responsiveRealValue !== item.responsiveValue) {
          return;
        }
        if (item.viewType === $const.INPUTVIEWTYPE.TIME_RESERVATION) {
          form.variables.input.stringAttributes.push({
            keyNameUuid: item.keyNameUuid,
            value: "时间预约组件占位值",
            registionUuid: this.state.registionUuid
          });
        } else if (item.type === $const.INPUTVALUETYPE.STRING && item.value !== undefined) {
          form.variables.input.stringAttributes.push({
            keyNameUuid: item.keyNameUuid,
            value: item.value,
            registionUuid: this.state.registionUuid
          });
        } else if (item.type === $const.INPUTVALUETYPE.INT && item.value !== undefined) {
          form.variables.input.intAttributes.push({
            keyNameUuid: item.keyNameUuid,
            value: item.value,
            registionUuid: this.state.registionUuid
          });
        }
      });
    // 先保存form提交信息
    this.props.gameStore.setGameForm(form, this.submitCallback);
  };

  reportData = type => {
    try {
      if (!this.state.uploadOss) return;
      agent.SassPlatform.report([
        {
          timestamp: Date.now(),
          uploadTrigger: "normal",
          controlPlaceholder: type,
          controlId: this.state.currentMd5,
          systemId: "101",
          controlLabel: this.state.uploadOss ? this.state.uploadOss.objectName : "",
          pageId: "gameApplyInfo"
        }
      ]);
    } catch (error) {
      console.error(`reportData error: ${error}`);
    }
  };

  submit = () => {
    this.setState({
      submitLoading: true
    });
    this.setGameStoreForm(this.state.registrationId || this.props.gameStore.gameRegistrationId);
    // 团队赛
    if (this.props.gameType === $const.SOURCE_TYPE.TEAM) {
      // 该表单有设置提交次数限制
      if (this.props.form.numLimit && !this.state.uploadOss) {
        this.props.gameStore.setSubmitLimit(
          this.state.submitNum,
          this.props.form.numLimit,
          this.props.node.nameUuidI18n[this.props.languageStore.lang],
          this.state.timeMeetingRef ? this.state.timeMeetingRef : null
        );
      } else {
        this.reportData("registration_start");
        // 直接提交表单
        this.props.gameStore
          .formSubmit()
          .then(() => {
            this.reportData("registration_success");
            this.props.teamStore.getTeamInfo(this.props.match.params.id);
            if (this.state.uploadOss) {
              this.reportData("sass_start");
              agent.SassPlatform.dockerUpload(this.largeFileInfo)
                .then(() => {
                  this.reportData("sass_success");
                  this.afterLargeUploadSucListener();
                  message.success("提交成功");
                })
                .catch(err => {
                  this.reportData("sass_fail");
                  this.setState({
                    largeUploadError: true,
                    largeUploadErrorReason: "提交失败，请刷新页面重试。"
                  });
                  console.log(err);
                });
            } else {
              message.success("提交成功");
            }
          })
          .catch(err => {
            this.reportData("registration_fail");
            console.log(err);
            if (
              err &&
              err.response &&
              err.response.body &&
              err.response.body.error &&
              err.response.body.error.message
            ) {
              if (
                err.response.body.error.message.indexOf("validate_failed: stage already expired") >
                -1
              ) {
                this.setState({
                  largeUploadError: true,
                  largeUploadErrorReason: "当前环节已结束，上传失败。"
                });
              }
            }
            message.error("提交失败。");
          });
      }
      this.setState({
        submitLoading: false
      });
    }
    // 个人赛
    else if (this.props.gameType === $const.SOURCE_TYPE.PERSON) {
      // 报名环节 直接提交
      if (this.props.isRegistration) {
        //提交时间预约组件的数据
        this.state.timeMeetingRef && this.state.timeMeetingRef.submitForm();
        this.props.gameStore
          .formSubmit()
          .then(res => {
            if (res && res.data) {
              this.summerGaSend();
              this.props.personGameStore.getGameInfo(this.props.match.params.id);
              message.success("报名成功");
              setTimeout(() => {
                // 投递成功以后刷新页面。
                window.location.reload();
              }, 1000);
            } else if (res && res.msg) {
              message.error(`报名失败，请稍后重试`);
            }
          })
          .catch(error => {
            if (
              error &&
              error.response &&
              error.response.body &&
              error.response.body.error &&
              error.response.body.error.message
            ) {
              message.error(`${error.response.body.error.message}`);
            } else {
              message.error("操作频繁，请稍后重试");
            }
          })
          .finally(() => {
            this.setState({
              submitLoading: false
            });
          });
      }
      // 非报名环节
      else {
        // 该表单有设置提交次数限制
        if (this.props.form.numLimit && !this.state.uploadOss) {
          this.props.gameStore.setSubmitLimit(
            this.state.submitNum,
            this.props.form.numLimit,
            this.props.node.nameUuidI18n[this.props.languageStore.lang],
            this.state.timeMeetingRef ? this.state.timeMeetingRef : null
          );
          this.setState({
            submitLoading: false
          });
        } else {
          // 直接提交表单
          //提交时间预约组件的数据
          this.state.timeMeetingRef && this.state.timeMeetingRef.submitForm();
          this.props.gameStore.formSubmit().then(() => {
            this.props.personGameStore.getGameInfo(this.props.match.params.id);
            this.setState({
              submitLoading: false
            });
            message.success("提交成功");
          });
        }
      }
    }
  };
  summerGaSend = () => {
    const myFlow = this.props.myFlow;
    const lang = this.props.languageStore.lang;
    if (localStorage) {
      if (!localStorage.getItem("isSummer")) {
        return;
      }
      let uuid;
      let from;
      from = localStorage.getItem("djiFrom");
      uuid = localStorage.getItem(
        `uuid_high_school_summer_apply_person_game_success_${myFlow.event.id}`
      );
      if (!from) {
        from = "default";
      }
      // 如果发送过就不发送了
      if (!uuid) {
        uuid = Math.random()
          .toString()
          .substr(2);
        localStorage &&
          localStorage.setItem(
            `uuid_high_school_summer_apply_person_game_success_${myFlow.event.id}`,
            uuid
          );
        ReactGA.event({
          category: "registration-system-apply-person-game",
          action: myFlow.event.titleUuidI18n[lang],
          label: from
        });
        this.props.commonStore.gTag("event", "registrationSystemApplyPersonGame", {
          pageName: "gameApplyInfo",
          competitionName: myFlow.event.titleUuidI18n[lang],
          eventLabel: from
        });
      }
    }
  };

  submitCallback = () => {
    // 参赛反馈环节
    if (this.props.node.stageType === $const.STAGE_TYPE.FEEDBACK) {
      this.changeToFeedBack();
    }
  };

  changeToFeedBack = () => {
    let detail;
    let node = this.props.node;
    let slug = false;
    this.state.inputs.forEach(item => {
      if (
        item.viewType === $const.INPUTVIEWTYPE.RADIO_FEEDBACK &&
        item.value === $const.FEEDBACK_VALUE
      ) {
        // 选择了正确的参赛选项
        slug = true;
      }
    });
    if (slug) {
      // 获取参赛反馈的文案
      if (node && node.paragraphs && node.paragraphs.nodes && node.paragraphs.nodes.length > 0) {
        node.paragraphs.nodes.forEach(item => {
          if (item.paragraphType === $const.PARAGRAPHTYPE.FEEDBACK) {
            detail = item.nameUuidI18n;
          }
        });
      }
      if (detail) {
        this.props.gameStore.setGameFeedback(detail);
        this.props.history.push("/game-complete");
      }
    }
  };

  normalInputOnchange = event => {
    this.setInputValue(event.target.value, event.target.id);
  };

  renderNormalInput = fileInfo => {
    const lang = this.props.languageStore.lang;
    return (
      <div key={fileInfo.id} className="form-input">
        <div uuid={fileInfo.keyNameUuid} className="normal-input">
          <div
            className={classnames({
              "normal-label": true,
              isRequired: fileInfo.required,
              isLeftTop: fileInfo.input.viewType === 9
            })}
          >
            <label>{fileInfo.labelUuidI18n[lang]}</label>
          </div>
          <div
            className={classnames({
              "normal-wrapper": true,
              isLeftTop: fileInfo.input.viewType === 9
            })}
          >
            {fileInfo.input.viewType === 0 ? (
              <input
                autoComplete="off"
                id={fileInfo.keyNameUuid}
                placeholder={fileInfo.placeholderUuidI18n[lang]}
                onChange={this.normalInputOnchange.bind(fileInfo.keyNameUuid)}
              ></input>
            ) : (
              <TextArea
                rows={5}
                autoComplete="off"
                id={fileInfo.keyNameUuid}
                placeholder={fileInfo.placeholderUuidI18n[lang]}
                onChange={this.normalInputOnchange.bind(fileInfo.keyNameUuid)}
              />
            )}
          </div>
        </div>
        {this.state.messages[fileInfo.keyNameUuid] ? (
          <div className="error">{this.state.messages[fileInfo.keyNameUuid]}</div>
        ) : null}
      </div>
    );
  };

  radioChange = (uuid, event) => {
    this.setInputValue(event.target.value, uuid);
  };

  renderRadio = fileInfo => {
    const lang = this.props.languageStore.lang;
    if (!fileInfo.goptions || !fileInfo.goptions.nodes || fileInfo.goptions.nodes.length < 1) {
      return null;
    }
    const options = fileInfo.goptions.nodes;
    return (
      <div key={fileInfo.id} className="form-input">
        <div uuid={fileInfo.keyNameUuid} className="radio">
          <div
            className={classnames({
              "normal-label": true,
              isRequired: fileInfo.required
            })}
          >
            <label>{fileInfo.labelUuidI18n[lang]}</label>
          </div>
          <div className="normal-wrapper">
            <RadioGroup onChange={this.radioChange.bind(this, fileInfo.keyNameUuid)}>
              {options.map(option => {
                return (
                  <Radio key={option.id} value={option.valueString}>
                    {option.contentUuidI18n[lang]}
                  </Radio>
                );
              })}
            </RadioGroup>
          </div>
        </div>
        {this.state.messages[fileInfo.keyNameUuid] ? (
          <div className="error">{this.state.messages[fileInfo.keyNameUuid]}</div>
        ) : null}
      </div>
    );
  };

  selectChange = (uuid, value, fileInfo) => {
    this.setInputValue(value, uuid);
  };

  renderSelect = fileInfo => {
    const lang = this.props.languageStore.lang;
    if (!fileInfo.goptions || !fileInfo.goptions.nodes || fileInfo.goptions.nodes.length < 1) {
      return null;
    }
    const options = fileInfo.goptions.nodes;
    return (
      <div key={fileInfo.id} className="form-input">
        <div uuid={fileInfo.keyNameUuid} className="select">
          <div
            className={classnames({
              "normal-label": true,
              isRequired: fileInfo.required
            })}
          >
            <label>{fileInfo.labelUuidI18n[lang]}</label>
          </div>
          <div className="normal-wrapper">
            <Select
              placeholder={
                fileInfo.placeholderUuidI18n && fileInfo.placeholderUuidI18n[lang]
                  ? fileInfo.placeholderUuidI18n[lang]
                  : ""
              }
              onChange={value => this.selectChange(fileInfo.keyNameUuid, value, fileInfo)}
            >
              {options.map(option => {
                return (
                  <Option key={option.id} value={option.valueString}>
                    {option.contentUuidI18n[lang]}
                  </Option>
                );
              })}
            </Select>
          </div>
        </div>
        {this.state.messages[fileInfo.keyNameUuid] ? (
          <div className="error">{this.state.messages[fileInfo.keyNameUuid]}</div>
        ) : null}
      </div>
    );
  };

  showJobSelectModal = (fileInfo, type) => {
    this.props.commonStore.gTag("event", "selectPost", {
      pageName: "personGameApplyInfo",
      buttonName: "选择职位"
    });

    this.setState({
      modalVisible: true,
      curRecuritInputUuid: fileInfo.keyNameUuid,
      jobSelectType: type
    });
  };

  deletePrimaryJob = () => {
    this.setState(
      {
        primaryJobName: "",
        primaryJobId: "",
        transferJobName: "",
        transferJobId: "",
        transferPositionState: false
      },
      this.setRecuritInputValue
    );
  };

  deleteTransferJob = () =>
    this.setState(
      {
        transferJobName: "",
        transferJobId: ""
      },
      this.setRecuritInputValue
    );

  onSelectJob = (record, jobSelectType) => {
    if (jobSelectType === "primary") {
      this.setState(
        {
          modalVisible: false,
          primaryJobName: record.jobTitle,
          primaryJobId: record.positionId,
          transferJobName: "",
          transferJobId: ""
        },
        this.setRecuritInputValue
      );
    } else if (jobSelectType === "transfer") {
      this.setState(
        {
          modalVisible: false,
          transferJobName: record.jobTitle,
          transferJobId: record.positionId
        },
        this.setRecuritInputValue
      );
    }
  };

  setRecuritInputValue = () => {
    const { primaryJobId, transferJobId } = this.state;
    const value =
      primaryJobId && transferJobId ? `${primaryJobId}||${transferJobId}` : `${primaryJobId}`;
    this.setInputValue(value, this.state.curRecuritInputUuid);
  };

  renderRecruitment = fileInfo => {
    const lang = this.props.languageStore.lang;
    const { primaryJobName, transferJobName } = this.state;

    return (
      <div key={fileInfo.id} className="form-recruitment">
        <div
          className={classnames({
            "form-recruitment--label": true,
            "form-recruitment--label-required": fileInfo.required
          })}
        >
          {fileInfo.labelUuidI18n[lang]}
        </div>
        <div uuid={fileInfo.keyNameUuid} className="form-recruitment__box">
          <div
            className="form-recruitment__box--select-btn"
            onClick={() => this.showJobSelectModal(fileInfo, "primary")}
          >
            {"选择职位"}
          </div>
          {primaryJobName ? (
            <div className="form-recruitment__box--job-box">
              <div className="form-recruitment__box--name">{`投递职位：${primaryJobName}`}</div>
              <Icon
                type="close"
                className="form-recruitment__box--delete"
                onClick={() => this.deletePrimaryJob(fileInfo.keyNameUuid)}
              />
            </div>
          ) : null}
        </div>
        {this.state.transferPositionState ? (
          <Fragment>
            <div className="form-recruitment--title">{"意向信息收集"}</div>
            <div uuid={fileInfo.keyNameUuid} className="form-recruitment__box">
              <div
                className="form-recruitment__box--transfer-btn"
                onClick={() => this.showJobSelectModal(fileInfo, "transfer")}
              >
                {"点击选择其他感兴趣的职位"}
              </div>
              {transferJobName ? (
                <div className="form-recruitment__box--job-box">
                  <div className="form-recruitment__box--name">
                    {`感兴趣的职位：${transferJobName}`}
                  </div>
                  <Icon
                    type="close"
                    className="form-recruitment__box--delete"
                    onClick={() =>
                      this.deleteTransferJob(fileInfo.keyNameUuid, fileInfo.responsiveRealValue)
                    }
                  />
                </div>
              ) : null}
            </div>
            <Alert
              className="form-recruitment__box--alert"
              message={transferJobDesc}
              type="warning"
              showIcon
            />
          </Fragment>
        ) : null}
        {this.state.messages[fileInfo.keyNameUuid] ? (
          <div className="form-recruitment--error">{this.state.messages[fileInfo.keyNameUuid]}</div>
        ) : null}
      </div>
    );
  };

  onClick = ref => {
    this.setState({
      timeMeetingRef: ref
    });
  };
  renderMeeting = fileInfo => {
    const lang = this.props.languageStore.lang;
    return (
      <div key={fileInfo.id} className="form-input">
        <div uuid={fileInfo.keyNameUuid} className="select">
          <div
            className={classnames({
              "normal-label": true,
              isRequired: fileInfo.required,
              isTimeMeeting: true
            })}
            ref={this.timeMeetingInput}
          >
            <label style={{ fontSize: "18px", fontWeight: "bold" }}>
              {fileInfo.labelUuidI18n[lang]}
            </label>
            <br />
            <label>{fileInfo.placeholderUuidI18n[lang]}</label>
          </div>
          <div>
            {this.props.meeting && (
              <GameTimeReservation
                required={fileInfo.required}
                gameData={this.props.gameData}
                stageId={this.stageId}
                meeting={this.props.meeting}
                ref={this.timeReservationComponent}
                onClick={this.onClick}
              />
            )}
          </div>
        </div>
        {this.state.messages[fileInfo.keyNameUuid] ? (
          <div className="error">{this.state.messages[fileInfo.keyNameUuid]}</div>
        ) : null}
      </div>
    );
  };

  renderInput = item => {
    let content = null;
    if (item.input) {
      switch (item.input.viewType) {
        case $const.INPUTVIEWTYPE.UPLOAD:
          content = this.renderFileUpload(item);
          break;
        case $const.INPUTVIEWTYPE.SUBMIT:
          content = this.renderSubmitButton(item);
          break;
        case $const.INPUTVIEWTYPE.TEXT_AREA:
        case $const.INPUTVIEWTYPE.TEXT:
          content = this.renderNormalInput(item);
          break;
        case $const.INPUTVIEWTYPE.RADIO:
          content = this.renderRadio(item);
          break;
        case $const.INPUTVIEWTYPE.RADIO_FEEDBACK:
          content = this.renderRadio(item);
          break;
        case $const.INPUTVIEWTYPE.SELECT:
        case $const.INPUTVIEWTYPE.TECH_DIRECTION_SELECT:
          content = this.renderSelect(item);
          break;
        case $const.INPUTVIEWTYPE.DIVISION:
          content = this.renderSelect(item);
          break;
        case $const.INPUTVIEWTYPE.TIME_RESERVATION:
          content = this.props.meeting ? this.renderMeeting(item) : null; // 团队赛不应该展示时间预约组件 meeting只有个人赛的时候有值
          break;
        case $const.INPUTVIEWTYPE.CHOOSE_JOB:
          content = this.renderRecruitment(item); // 选择职位模态框
          break;
        case $const.INPUTVIEWTYPE.UPLOAD_DOCKER_FILE:
          content = this.renderLargeFileUpload(item); // docker镜像上传
          break;
        default:
          break;
      }
    }
    return content;
  };

  closeLargeUploadProgressModal = cls => {
    if (this.state.isLargeUploadReady) {
      this.largeUploadCancel();
      return;
    }
    const lang = this.props.languageStore.lang;
    Modal.confirm({
      iconType: <div />,
      cancelText: this.props.languageStore.getResource(lang, "CANCEL"),
      okText: this.props.languageStore.getResource(lang, "CONFIRM"),
      onCancel: () => {},
      content: (
        <div className="large-upload-progress-modal-box__sub-title">
          {this.props.languageStore.getResource(lang, "IS_CANCEL_UPLOAD_DOCKER")}
        </div>
      ),
      onOk: () => {
        this.largeUploadCancel();
        const dom = document.getElementsByClassName(cls)[0];
        dom && this.props.commonStore.trackReport.fnTrackByEle(dom, "data-click");
      }
    });
  };

  largeUploadAgain = () => {
    window.location.reload();
  };

  closeGameRegistrationModal = () => {
    this.setState({
      gameRegistrationModal: false
    });
  };

  register = () => {
    // 锁定队伍
    // 先判断是否有报名号，有的话就不用注册了
    this.setState({
      registerButtonLoading: true
    });
    this.props.gameStore
      .registration({
        variables: {
          input: {
            attributes: {
              eventId: this.props.teamStore.teamInfo.gevent.id,
              sourceType: $const.SOURCE_TYPE.TEAM,
              sourceId: this.props.teamStore.teamInfo.id,
              flowId: this.props.teamStore.teamInfo.myFlow.id
            }
          }
        }
      })
      .then(() => {
        this.setState({
          registrationId: this.props.gameStore.gameRegistrationId,
          registerButtonLoading: false,
          gameRegistrationModal: false
        });
        this.setGameStoreForm(this.props.gameStore.gameRegistrationId);
        this.startUploadLargeFile();
      });
  };

  handleChangeTransferPositionState = state => {
    if (!state) {
      this.setState({
        transferPositionState: state,
        transferJobName: "",
        transferJobId: ""
      });
    } else {
      this.setState({
        transferPositionState: state
      });
    }
  };

  render() {
    const formInputs = this.props.formInputs;
    const lang = this.props.languageStore.lang;
    // 达到提交次数 且不是无限提交环节
    if (this.state.submitNum === this.props.form.numLimit && !this.props.isLoop) {
      return null;
    }
    // 无限提交环节 状态是待处理的 不展示表单
    if (this.props.status === $const.STAGE_STATUS.PROGRESS && this.props.isLoop) {
      return null;
    }
    const teamInfo = this.props.teamStore.teamInfo;

    return (
      <div className="game-form">
        <div className="form-content">
          {this.state.submitLoading ? (
            <Spin
              style={{
                left: "0px",
                top: "0",
                background: "rgba(0, 0, 0, 0.4)",
                borderRadius: "4px",
                width: "100%",
                height: "100%",
                position: "absolute",
                zIndex: "10",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            />
          ) : null}
          {formInputs.map(input => {
            if (
              input &&
              input.input &&
              input.input.viewType === $const.INPUTVIEWTYPE.PERSONAL_INFO
            ) {
              return (
                <PersonalInfoInput
                  onRef={el => (this.personalInfoRef = el)}
                  input={input}
                  lang={lang}
                />
              );
            }

            if (input.responsiveFormInputId && input.responsiveValue) {
              // 存在前置条件
              let myInput = this.state.inputs.find(item => {
                return item.keyNameUuid === input.keyNameUuid;
              });
              if (myInput && myInput.responsiveRealValue === input.responsiveValue) {
                return this.renderInput(input);
              }
              return null;
            }

            return this.renderInput(input);
          })}
        </div>
        <Modal1 state={this.state.requiredModal} close={this.closeRequiredModal}>
          <div className="input-tip">你有必填项目未填写</div>
        </Modal1>
        <JobSelect
          visible={this.state.modalVisible}
          onCancel={() => this.setState({ modalVisible: false })}
          onSelect={this.onSelectJob}
          jobSelectType={this.state.jobSelectType}
          primaryJobId={this.state.primaryJobId}
          changeTransferPositionState={this.handleChangeTransferPositionState}
        />
        {this.state.largeUploadProgressVisible && (
          <div
            className="large-upload-progress-modal"
            data-log={$util.log({
              cardId: "docker_upload_progress_modal"
            })}
          >
            <div className="large-upload-progress-modal-box">
              {this.state.largeUploadError ? (
                <div
                  className="large-upload-progress-modal-box-info"
                  data-exp="0"
                  data-log={$util.log({
                    uploadStatus: "failed",
                    uploadErrReason: this.state.largeUploadErrorReason
                  })}
                >
                  <Icon
                    className="large-upload-progress-modal-box__failed-icon"
                    type="info-circle"
                    theme="filled"
                  />
                  <Language
                    className="large-upload-progress-modal-box__title"
                    resource="DOCKER_UPLOAD_FAILED"
                  />
                  <Language
                    className="large-upload-progress-modal-box__sub-title"
                    resource="DOCKER_UPLOAD_FAILED_INFO"
                    keys={[this.state.largeUploadErrorReason]}
                  />
                </div>
              ) : (
                <div className="large-upload-progress-modal-box-info">
                  {this.state.isLargeUploadReady && (
                    <Icon
                      data-exp="0"
                      data-log={$util.log({
                        uploadStatus: "sucess"
                      })}
                      className="large-upload-progress-modal-box__success-icon"
                      type="check-circle"
                      theme="filled"
                    />
                  )}
                  <Language
                    className="large-upload-progress-modal-box__title"
                    resource={
                      !this.state.isLargeUploadReady ? "DOCKER_UPLOAD" : "DOCKER_UPLOAD_SUCCEED"
                    }
                  />
                  <Language
                    className="large-upload-progress-modal-box__sub-title"
                    resource={
                      !this.state.isLargeUploadReady
                        ? "DOCKER_UPLOAD_INFO_1"
                        : "DOCKER_UPLOAD_SUCCEED_INFO"
                    }
                  />
                  {!this.state.isLargeUploadReady && (
                    <Language
                      className="large-upload-progress-modal-box__sub-title"
                      resource="DOCKER_UPLOAD_INFO_2"
                    />
                  )}
                </div>
              )}
              <Progress
                percent={this.state.largeFileProgress}
                className="large-upload-progress-modal-box__progress"
              />
              {this.state.largeUploadError ? (
                <Button
                  data-click
                  data-log={$util.log({
                    buttonId: "docker_upload_again",
                    buttonPosition: 1
                  })}
                  onClick={this.largeUploadAgain}
                  className="large-upload-progress-modal-box__button"
                >
                  <Language resource="DOCKER_UPLOAD_AGAIN" />
                </Button>
              ) : (
                <Button
                  data-log={$util.log({
                    buttonId: !this.state.isLargeUploadReady ? "docker_upload_cacel" : "close",
                    buttonPosition: 1
                  })}
                  onClick={() =>
                    this.closeLargeUploadProgressModal("large-upload-progress-modal-box__button")
                  }
                  className="large-upload-progress-modal-box__button"
                >
                  <Language
                    resource={!this.state.isLargeUploadReady ? "DOCKER_UPLOAD_CANCEL" : "CLOSE"}
                  />
                </Button>
              )}
            </div>
          </div>
        )}
        <Modal1
          class="sumit-limit-tip"
          title={<Language resource="CONFIRM_SUBMIT_FORM" />}
          state={this.state.showBeforeUploadTip}
          close={this.closeBeforeUploadTip}
        >
          <div className="confirm-tip">
            {lang === "zh"
              ? `您已提交${this.state.submitNum}次${
                  this.props.node.nameUuidI18n[this.props.languageStore.lang]
                }，剩余${this.props.form.numLimit -
                  this.state.submitNum}次提交机会，请确认是否提交此次${
                  this.props.node.nameUuidI18n[this.props.languageStore.lang]
                }？提交后，您将剩余${this.props.form.numLimit - this.state.submitNum - 1}次${
                  this.props.node.nameUuidI18n[this.props.languageStore.lang]
                }提交机会。`
              : `You have submitted ${this.state.submitNum} time${
                  this.state.submitNum > 1 ? "s" : ""
                }, remaining ${this.props.form.numLimit - this.state.submitNum} time${
                  this.props.form.numLimit - this.state.submitNum ? "s" : ""
                }. Please confirm to submit ${
                  this.props.node.nameUuidI18n[this.props.languageStore.lang]
                }. After submitting, you will have ${this.props.gameStore.submitLimit.limitSum -
                  this.state.submitNum -
                  1} time${
                  this.props.form.numLimit - this.state.submitNum - 1 ? "s" : ""
                } remaining.`}
          </div>
          <div className="operate">
            <Button onClick={this.confirmBeforeUploadTip}>
              <Language resource="CONFIRM" />
            </Button>
          </div>
        </Modal1>
        {/* 大文件上传的提示报名的队伍锁定 */}
        <Modal1
          className="model-confirm-tip"
          title={<Language resource="CONFIRM_SUBMIT" />}
          state={this.state.gameRegistrationModal}
          close={this.closeGameRegistrationModal}
        >
          <div className="confirm-tip">
            {this.props.languageStore
              .getResource(lang, "CONFIRM_TIP")
              .replace("XXX", teamInfo.gevent && teamInfo.gevent.titleUuidI18n[lang])}
          </div>
          <div className="operate">
            <Button
              disabled={this.state.registerButtonLoading}
              loading={this.state.registerButtonLoading}
              onClick={this.register}
            >
              <Language resource="CONFIRM" />
            </Button>
          </div>
        </Modal1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/formList/gameForm/index.js